import axios from "../../axios";

const api = {
  getTransportTypes(accessToken) {
    const config = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get("/transportation/transport-types", config).then(({ data }) => data);
  }
};

export default api;